import { AccountKeyOutlineIcon } from './AccountKeyOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 85086B0D-4678-4B8E-9824-308F59F09C0F
 * name account-key-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-key-outline.svg
 * tags
 * - Account / User 
 */
export const UserKeyOutlineIcon = AccountKeyOutlineIcon;
export default UserKeyOutlineIcon